<div class="c-comparison-table">
	<div class="jsdelivr-wrapper">
		<div></div>
		<div></div>
		<div>
			<div></div>
		</div>
	</div>
	<div class="table-header">
		<div></div>
		<div>
			{{#if competitorImgSrc}}
				<img
					width="{{competitorImgWidth}}"
					height="{{competitorImgHeight}}"
					src="{{competitorImgSrc}}"
					srcset={{competitorImgSrcset}}>
				{{else}}
					{{{competitorTitleEl}}}
				{{/if}}
		</div>
		<div>
			<img width="115" height="28" src="{{@shared.assetsHost}}/img/jsDelivr.logo.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Multi-CDN
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Uses multiple independent CDN providers', 'right'">
		</div>
		<div class="compare-detail left">1</div>
		<div class="compare-detail right">4</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Multi-DNS
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Uses multiple independent DNS providers', 'right'">
		</div>
		<div class="compare-detail left">1</div>
		<div class="compare-detail right">2</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Smart load-balancing
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Chooses the best provider for each individual user', 'right'">
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Combining multiple files
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Fully featured API
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Package version listings, directory listings, and detailed usage stats', 'right'">
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Cache purge API
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Instantly refresh a file cached on the CDN', 'right'">
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			Download stats
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>

	<div class="table-row">
		<div class="compare-subject">
			POPs in China
			<img width="20"
				height="20"
				src="{{@shared.assetsHost}}/img/icons/information.svg"
				as-tooltip="'Including a valid ICP license', 'right'">
		</div>
		<div class="compare-detail left">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.disabled.svg">
		</div>
		<div class="compare-detail right">
			<img width="32" height="32" src="{{@shared.assetsHost}}/img/icons/check-circle.full.svg">
		</div>
	</div>
</div>

<script>
	const tooltip = require('../../assets/js/decorators/tooltip');

	component.exports = {
		decorators: {
			tooltip,
		},
	};
</script>
